export default [
  {
    title: "Privacy Proxy for IP Protection",
    desc: "IP Protection is a proposal to hide users’ IP addresses to prevent cross-site tracking by two-hop proxying users’ traffic. We work on the Privacy Proxy, which serves billions of Chrome users’ traffic to protect their privacy with high reliability and performance.",
    links: [
        {
            text: "IP Protection",
            url: "https://developers.google.com/privacy-sandbox/protections/ip-protection"
        },
        {
            text: "Tech Talk",
            url: "https://www.youtube.com/watch?v=g0tfTVnZsto"
        },

    ]
  },
  {
    title: "Automatic Verification of Oblivious Algorithms",
    desc: "Even when the data content is encrypted, an attacker can watch the memory, disk, and network access patterns of a program and infer a significant amount of secret information. Oblivious algorithms prevent this type of information leakage by making the access pattern independent of the secret input data. In this  project, we developed a program checker for automatically verifying that a given algorithm is oblivious using symbolic execution.",
    links: [
        {
            text: "Presentation (USENIX Security '21)",
            url: "https://www.usenix.org/conference/usenixsecurity21/presentation/son"
        }
    ]
  },
  {
    title: "Program Partitioning Framework for Hardware Enclaves",
    desc: "Hardware enclaves like Intel SGX protect sensitive data of an application even when an OS is malicious. However, simply putting a legacy application into an enclave can be insecure and degrade the performance significantly. We devised a framework that automatically partitions an application into trusted and untrusted parts with program analysis techniques and an optimized language runtime implementation for hardware enclaves.",
    links: [
        {
            text: "Presentation (USENIX Security '20)",
            url: "https://www.usenix.org/conference/usenixsecurity20/presentation/tsai"
        }]
  },
  {
    title: "Cloud-Scale Multitenant IPsec Gateway",
    desc: "Cloud service providers dedicate an IPsec gateway VM to each tenant to offer VPN connections to the virtual networks. We found that this approach wastes a significant amount of resources due to over-provisioning and passive redundancy for high availability. We designed a new distributed IPsec gateway service which can serve multiple tenants using shared resources.",
    links: [
      {
        text: "Presentation (ATC '17)",
        url: "https://www.usenix.org/conference/atc17/program/presentation/son"
      }

    ]
  },
  {
    title: "Data Plane Verification of Networks Containing Middleboxes",
    desc: "VeriFlow was designed to verify the correctness of Software Defined Network (SDN) in real-time. To check traditional networks, we modeled various network devices from different vendors to construct the vendor-agnostic abstraction of networks for verification. I survyed and studied various types of network devices and modeled one of them from scratch.",
    links: [
      {
        text: "Presentation (NSDI '13)",
        url: "https://www.usenix.org/conference/nsdi13/technical-sessions/presentation/khurshid"
      },
      {
        text: "Commercialization",
        url: "http://www.veriflow.net/"
      }
    ]
  },
  {
    title: "Efficient Virtual Machine Live Migration and Checkpoint",
    desc: "The high network bandwidth consumption and long migration time hinder the wide deployment of virtual machine (VM) live migration in data centers. We improved the performance of VM live migration and checkpoint by deduplicating data overlap between memory and disk.",
    links: [
      {
        text: "VM Checkpoint Project Page",
        url: "https://csap.snu.ac.kr/software/xencheckpointing"
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/pages/ProjectPage/project-items.js